import { CaseTypeWire } from 'app/area/risk-matrix-administration/types';
import { ComplexValue } from 'ui';

export const mapCaseTypesToStore = (caseTypesWire: CaseTypeWire[]): ComplexValue<number>[] =>
  caseTypesWire.map(caseTypeWire => ({
    value: caseTypeWire.v,
    description: caseTypeWire.d,
    longDescription: caseTypeWire.ld,
    disabled: caseTypeWire.disabled
  }));
